export const winnerPhotoNames = Array(130)
  .fill(null)
  .map((_, i) => `wof-${i + 1}`)
  .filter(
    (photoName) =>
      ['wof-11', 'wof-43', 'wof-64', 'wof-99'].includes(photoName) === false
  ); // Exclude these photos
